<template>
  <div class="account">
    <div class="account-title">{{ $t('sendFunding') }}</div>
    <div class="account-wrap">
      <div class="account-send">
        <div class="account-send__type">
          <Radio value="hola" name="hola" class="radio" v-model="sendType">Hola {{ $t('user') }}</Radio>
          <Radio value="xbit" name="xbit" class="radio" v-model="sendType">XPR {{ $t('walletNumber') }}</Radio>
        </div>
        <form @submit.prevent="submit" class="account-form">
          <div class="account-row option-row" v-if="sendType === 'hola'">
            <div class="account-row__title">{{ $t('chooseOption') }}:</div>
            <div class="account-option">
              <label class="account-label">
                <input type="radio" value="nickname" name="nickname" v-model="holaSendType" />
                <span>{{ $t('nickname') }}</span>
              </label>
              <label class="account-label">
                <input type="radio" value="email" name="email" v-model="holaSendType" />
                <span>{{ $t('email') }}</span>
              </label>
            </div>
            <BaseInput
              v-if="holaSendType === 'nickname'"
              v-model="form.nickname"
              :label="$t('formNickName')"
              :invalid="$v.form.nickname.$error"
              :error="nicknameError"
              @input="normalizeNickname"
              class="input-nickname"
              @blur="$v.form.nickname.$touch"
            />
            <BaseInput
              v-if="holaSendType === 'email'"
              v-model="form.email"
              :label="$t('email')"
              @input="resetErrors"
              :invalid="$v.form.email.$error"
              :error="emailError"
              @blur="$v.form.email.$touch"
            />
          </div>
          <div class="account-row" v-if="sendType === 'xbit'">
            <BaseInput
              v-model="form.account"
              :label="`XPR ${$t('walletNumber')}`"
              :invalid="$v.form.account.$error"
              :error="apiAccountError"
              @blur="$v.form.account.$touch"
            />
          </div>
          <div class="account-row">
            <BaseInput
              v-model="form.amount"
              :label="$t('amount')"
              :invalid="$v.form.amount.$error"
              :error="apiAmountError"
              @blur="$v.form.amount.$touch"
              @input="updateCommission"
              type="number"
            />
            <div id="xpr_fee" class="account-row__fee">
              <span>${{ parseFloat(xprCommission).toFixed(2) }}</span> fee
            </div>
          </div>
          <div class="account-row">
            <BaseInput
              v-model="form.description"
              :label="$t('descriptionOptional')"
              multiline
              rows="5"
              :invalid="$v.form.description.$error"
              :error="apiDescriptionError"
              @blur="$v.form.description.$touch"
            />
          </div>
          <div class="account-action">
            <BaseButton oval :disabled="$v.form.$invalid || loading || submitting" :loading="loading || submitting">
              {{ $t('buttonSend') }}
              <span>${{ parseFloat(form.totalAmount).toFixed(2) }}</span>
            </BaseButton>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { maxLength, minLength, required, helpers, email, minValue, between } from 'vuelidate/lib/validators'
import { Radio } from 'vue-checkbox-radio'
import { debounce } from 'lodash'
import { TransactionType } from '@/store/modules/wallet'
const NICKNAME_MIN_LENGTH = 4
const alphaNumHyphenUnderscoreValidator = helpers.regex('alphaNumAndDot', /^[-a-zA-Z0-9_]+$/i)
export default {
  name: 'wallet-send-receive',
  data () {
    return {
      submitting: false,
      error: null,
      serverErrors: null,
      isValidPhone: false,
      holaSendType: 'nickname',
      sendType: 'hola',
      loading: false,
      holaUserId: null,
      holaUserNickname: null,
      form: {
        email: null,
        account: null,
        amount: null,
        description: null,
        phone: null,
        nickname: null,
        totalAmount: 0
      },
      xprCommission: 0,
      commissionLoading: false
    }
  },
  components: {
    Radio
  },
  metaInfo () {
    return {
      title: this.$t('titleWallet')
    }
  },
  validations () {
    if (this.sendType === 'hola') {
      if (this.holaSendType === 'nickname') {
        return {
          form: {
            amount: {
              required,
              minValue: minValue(1),
              between (value) {
                return between(
                  0,
                  this.xPayBalance && this.xPayBalance.balance_usd
                )(parseFloat(value) + parseFloat(this.xprCommission))
              }
            },
            description: {
              maxLength: maxLength(512)
            },
            nickname: {
              required,
              minLength: minLength(4),
              alphaNumHyphenUnderscoreValidator,
              server () {
                return !this.error
              }
            }
          }
        }
      } else {
        return {
          form: {
            amount: {
              required,
              minValue: minValue(1),
              between (value) {
                return between(
                  0,
                  this.xPayBalance && this.xPayBalance.balance_usd
                )(parseFloat(value) + parseFloat(this.xprCommission))
              }
            },
            description: {
              maxLength: maxLength(512)
            },
            email: {
              required,
              email
            }
          }
        }
      }
    } else {
      return {
        form: {
          account: {
            required
          },
          amount: {
            required,
            minValue: minValue(1),
            between (value) {
              return between(
                0,
                this.xPayBalance && this.xPayBalance.balance_usd
              )(parseFloat(value) + parseFloat(this.xprCommission))
            }
          },
          description: {
            maxLength: maxLength(512)
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      walletInfo: 'wallet/walletInfo',
      xPayBalance: 'wallet/xPayBalance',
      user: 'auth/user'
    }),
    apiEmailError () {
      if (!this.$v.form.email.required) {
        return this.$t('errorEmptyField')
      }
      return this.$t('errorEmptyField')
    },
    apiAccountError () {
      if (!this.$v.form.account.required) {
        return this.$t('errorEmptyField')
      }
      return this.$t('errorEmptyField')
    },
    apiAmountError () {
      if (!this.$v.form.amount.required) {
        return this.$t('errorEmptyField')
      }
      if (!this.$v.form.amount.minValue) {
        return this.$t('errorMinimalValueField', { amount: 1 })
      }
      if (!this.$v.form.amount.between) {
        return this.$t('notEnoughMoneyOnAccount')
      }
      return this.$t('errorEmptyField')
    },
    apiDescriptionError () {
      if (!this.$v.form.description.maxLength) {
        return `${this.$t('errorMaxLength_begin')} 512 ${this.$t('errorLength_end')}`
      }
      return this.$t('errorEmptyField')
    },
    phoneError () {
      let error = this.$t('errorEmptyField')
      if (!this.$v.form.phone.phone) {
        error = this.$t('errorPhoneInvalid')
      }
      if (!this.$v.form.phone.server) {
        error = this.$t('affiliate_' + this.error.replace(/\s/g, ''))
      }
      return error
    },
    nicknameError () {
      let error = this.$t('errorEmptyField')
      if (!this.$v.form.nickname.minlength) {
        error = `${this.$t('errorMinLength_begin')} ${NICKNAME_MIN_LENGTH} ${this.$t('errorLength_end')}`
      }
      if (!this.$v.form.nickname.alphaNumHyphenUnderscoreValidator) {
        error = this.$t('errorAlphanumericDashUnderscore')
      }
      if (!this.$v.form.nickname.server) {
        error = this.$t('affiliate_' + this.error.replace(/\s/g, ''))
      }
      return error
    },
    emailError () {
      let error = this.$t('errorEmptyField')
      if (!this.$v.form.email.email) error = this.$t('errorEmailInvalid')
      return error
    }
  },
  methods: {
    ...mapActions({
      getUserIdReq: 'wallet/getUserId',
      transferFunds: 'wallet/transferFunds',
      getCommission: 'wallet/getCommission',
      fetchXpayBalance: 'wallet/fetchXpayBalance'
    }),
    updateCommission: debounce(async function () {
      this.commissionLoading = true
      try {
        const result = await this.getCommission({
          amount: this.form.amount,
          transactionType: TransactionType.TRANSFER_OUTGOING
        })

        this.xprCommission = result.commissionFee
        this.form.totalAmount = parseFloat(this.form.amount) + parseFloat(this.xprCommission)
      } finally {
        this.commissionLoading = false
      }
    }, 800),
    handlePhoneInput (phone) {
      this.form.phone = phone
      this.serverErrors = null
    },
    normalizeNickname () {
      this.form.nickname = this.form.nickname.toLowerCase()
    },
    resetErrors () {
      this.error = null
    },
    submit () {
      this.errors = {}
      this.$v.form.$touch()
      if (this.$v.form.$invalid || this.submitting || this.loading) return
      if (this.sendType === 'xbit') {
        const data = {}
        data.amount = parseInt(this.form.amount)
        data.xbitAccount = this.form.account
        data.toNickname = this.form.account
        if (this.form.description) {
          data.description = this.form.description
        }
        data.nickname = this.user.nickname
        this.sendFundsReq(data)
      } else {
        if (this.holaSendType === 'nickname') {
          this.getUserId(this.form.nickname, 'nickname')
        } else {
          this.getUserId(this.form.email, 'email')
        }
      }
    },
    async getUserId (value, type) {
      try {
        this.loading = true
        const user = await this.getUserIdReq({ value, type })
        const data = {}
        data.amount = parseInt(this.form.amount)
        if (this.form.description) {
          data.description = this.form.description
        }
        data.toUserId = user.data.userId
        data.toNickname = user.data.nickname
        data.nickname = this.user.nickname
        this.sendFundsReq(data)
      } catch (e) {
        // eslint-disable-next-line no-console
        if (e.response.status === 404) {
          this.$modal.show('error', { error: this.$t('userNotFound') })
        }
      } finally {
        this.loading = false
      }
    },
    async sendFundsReq (data) {
      try {
        this.submitting = true
        await this.transferFunds(data)
        const { apiKey, apiSecret } = this.walletInfo
        this.fetchXpayBalance({
          api_key: apiKey,
          secret_key: apiSecret
        })
        this.$modal.show('success')
        this.$router.push({ name: 'wallet-transactions' })
      } catch (e) {
        // eslint-disable-next-line no-console
        if (e.response.status === 404 || e.response.data.data.type === 'not_exists') {
          this.$modal.show('error', { error: this.$t('userNotFound') })
        }
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.account {
  padding-right: 15px;
  max-height: 565px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 8px;
    position: absolute;
    background: rgba(17, 17, 17, 0.1);
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    position: absolute;
    z-index: -2;
  }
  &::-webkit-scrollbar-thumb {
    background: #00b764;
    border-radius: 5px;
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &-wrap {
    margin-top: 30px;
  }
  &-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 400px;
    height: auto;
    padding: 20px 15px;
    border-radius: 15px;
    background-color: #232f3f;
    margin: 0 auto;
    user-select: none;
    &__left {
      width: 40%;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      span {
        display: inline-block;
        position: absolute;
        left: 10px;
        bottom: 20px;
        color: $white;
        font-size: 26px;
      }
    }
    &__right {
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      margin-top: 30px;
      span {
        color: $white;
        font-size: 20px;
        margin-bottom: 10px;
      }
    }
    &__qrcode {
      width: 250px;
      height: 250px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  &-action {
    width: 100%;
    max-width: 300px;
    margin: 20px auto;
    button {
      width: 100%;
      padding: 15px 30px;
      background: #f7961d;
      color: $white;
      font-size: 16px;
      font-weight: bold;
      height: 50px;
      &.button--loading {
        background: #f7961d;
      }
      &.button--disabled {
        opacity: 0.5;
      }
    }
  }
  &-send {
    &__title {
      font-size: 14px;
      text-align: center;
      font-weight: bold;
      margin: 15px 0;
    }
    &__type {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      margin: 15px 0;
      .radio {
        width: 48%;
        padding: 10px;
        height: 40px;
        border: 1px solid #cecece;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  &-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    label {
      width: 100%;
    }
    &__fee {
      background-color: #b6babe;
      height: 40px;
      width: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-top: 24px;
      font-size: 12px;
      font-weight: 500;
      span {
        margin-right: 3px;
        font-size: 12px;
      }
    }
  }
  .account-label {
    display: flex;
    flex-direction: row;
    padding: 5px 0;
    cursor: pointer;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    margin-bottom: 0.375em;
    input {
      position: absolute;
      left: -9999px;
      &:checked + span {
        background-color: mix(#fff, $green, 84%);
        &:before {
          box-shadow: inset 0 0 0 0.4375em $green;
        }
      }
    }
    span {
      display: flex;
      align-items: center;
      padding: 0.375em 0.75em 0.375em 0.375em;
      border-radius: 99em; // or something higher...
      transition: 0.25s ease;
      &:hover {
        background-color: mix(#fff, $green, 84%);
      }
      &:before {
        display: flex;
        flex-shrink: 0;
        content: '';
        background-color: #fff;
        width: 1.5em;
        height: 1.5em;
        border-radius: 50%;
        margin-right: 0.375em;
        transition: 0.25s ease;
        box-shadow: inset 0 0 0 0.125em $green;
      }
    }
  }
}
</style>
<style lang="scss">
.account-send__type .radio {
  background: #00b764;
  color: $white;
  cursor: pointer;
  label {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    span {
      margin-right: 10px !important;
    }
  }
}
.option-row {
  display: flex;
  flex-direction: column !important;
  .account-option {
    padding: 15px 10px;
  }
  .radio {
    width: 100%;
    padding: 5px 0;
  }
}
</style>
